import Ajv from 'ajv';

import { capitalize } from './misc';
import { PHONE_TYPES } from 'config/app-config';

import nepMuleSchema from 'assets/schemas/nep-mule-schema.json';

const ajv = new Ajv({ strict: false });

ajv.addSchema(nepMuleSchema);

class Validations {
  _validate(value, definition) {
    const validate = ajv.getSchema(definition);

    return validate(value);
  }

  validatePostcode(value) {
    return this._validate(value, '#/definitions/TypePostcode');
  }
}

export const isValidField = (value, name) => {
  if (value === null) {
    return true;
  }
  const validations = new Validations();

  return validations[`validate${capitalize(name)}`](value);
};

export const getPhoneType = (phoneNumber) => {
  if (/^07/.test(phoneNumber)) {
    return PHONE_TYPES.MOBILE_PERSONAL;
  }

  return PHONE_TYPES.LANDLINE_HOME;
};
